import React from 'react'

import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg'

const LimeLight = ({ ...props }) => {
  return (
    <Svg
      width={69}
      height={46}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 69 46"
      {...props}
    >
      <Path opacity={0.2} d="M0 46 19.54 0h30.53L69 46H0Z" fill="url(#a)" />
      <Defs>
        <LinearGradient
          id="a"
          x1={34.5}
          y1={0}
          x2={33.498}
          y2={30.189}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#85B7FE" />
          <Stop offset={1} stopColor="#D3E5FF" stopOpacity={0} />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default LimeLight
